import gql from 'graphql-tag';

import mainDisplayObjectFragment from './mainDisplayObjectFragment';

export const recentlyViewedObjectFragment = gql`
  fragment recentlyViewedObjectFragment on RecentlyViewedObject {
    dokkioClass
    integrationID
    integrationItemKind
    mainDisplayObject {
      ...mainDisplayObjectFragment
    }
    lastViewedAt
  }
  ${mainDisplayObjectFragment}
`;
export default recentlyViewedObjectFragment;
